import { Box, Typography } from '@mui/material';
import { SanitizedHtml, useAsyncValue } from 'framework/utils';
import { useApplicationSettings } from 'framework/uiTheme';
import { ProjectReviewViolation } from '../../types';

const StaleItemMessage = ({ message }: { message: Nullable<string> }) => {
  const { useDefaultTextTransformer } = useApplicationSettings();
  const { mapAsyncTags = () => {}, mapTags = () => {} } = useDefaultTextTransformer?.() ?? {};

  const syncData = mapTags(message ?? '');
  const asyncData = useAsyncValue(async () => mapAsyncTags(syncData), [syncData]);

  return (
    <Typography variant="subtitle1" color="warning" sx={{ whiteSpace: 'pre-wrap' }}>
      <SanitizedHtml wrapperTag="span" html={asyncData || syncData} />
    </Typography>
  );
};

interface StaleItemsListProps {
  staleItems: ProjectReviewViolation[];
}

const StaleItemsList = ({ staleItems }: StaleItemsListProps) => {
  if (!staleItems.length) return null;

  return (
    <>
      {staleItems.map(staleItem => (
        <Box
          key={`${staleItem.entityType}-${staleItem.entityId}-${staleItem.code}`}
          sx={{ bgcolor: 'background.warning', px: 1.25, py: 0.75, mb: 1 }}
        >
          <StaleItemMessage message={staleItem.message} />
        </Box>
      ))}
    </>
  );
};

export default StaleItemsList;
